import React, { useCallback, useId } from 'react';
import { useField } from 'react-final-form';
import { v4 } from 'uuid';

import BaseSettingCard from '@dashboard/components/platform-settings/BaseSettingCard';
import { FWorkflowTriggerFragment } from '@dashboard/generated/wp/platform';
import { FormControl, MenuItem, Select, SelectChangeEvent, Stack, Typography } from '@mui/material';

import ServiceIcon from '../images/ServiceIcon';

type TTriggerType = 'STRIPE' | 'WAYPOINT_API' | 'HTTP_POST';

type Props = {
  type: TTriggerType;
  children: JsxNode;
};
export default function TriggerSectionWrapper({ type, children }: Props) {
  const { onChange } = useField<FWorkflowTriggerFragment[]>('triggers').input;
  const labelId = useId();

  const handleChange = useCallback(
    (ev: SelectChangeEvent) => {
      onChange(getSelectionArrayValue(ev.target.value));
    },
    [onChange]
  );
  return (
    <BaseSettingCard title="Trigger">
      <Stack spacing={2} mt={3}>
        <FormControl>
          <Select size="small" labelId={labelId} value={type} onChange={handleChange}>
            {renderSelectMenuItem('WAYPOINT_API', 'Waypoint API')}
            {renderSelectMenuItem('HTTP_POST', 'HTTP Post')}
          </Select>
        </FormControl>
        {children}
      </Stack>
    </BaseSettingCard>
  );
}

function renderSelectMenuItem(value: TTriggerType, label: string) {
  return (
    <MenuItem value={value}>
      <Stack direction="row" spacing={1.5}>
        <ServiceIcon type={value} />
        <Typography>{label}</Typography>
      </Stack>
    </MenuItem>
  );
}

const BASE58_ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';

function encodeBase58(uuid: string): string {
  let b = BigInt('0x' + uuid.replace(/[^a-f0-9]/gi, ''));
  let u58 = '';
  do {
    const index = parseInt((b % BigInt(BASE58_ALPHABET.length)).toString(), 10);
    u58 = BASE58_ALPHABET[index] + u58;
    b = b / BigInt(BASE58_ALPHABET.length);
  } while (b > 0);
  return u58;
}

function getSelectionArrayValue(selection: unknown): FWorkflowTriggerFragment[] {
  switch (selection) {
    case 'WAYPOINT_API':
      return [];
    case 'HTTP_POST':
      return [{ httpPost: { token: encodeBase58(v4() + v4() + v4()).slice(0, 32) } }];
    default:
      return [];
  }
}
